export enum PdfSettingsFooterBlocksEnum {
  FOOTER_INFO = 'FOOTER_INFO',
  IMAGE = 'IMAGE',
  TEXT = 'TEXT',
}
